import React, { Fragment } from 'react'
import { hasFeature } from '../../../van-shared/utils/features'

import { Button, Page } from '@fielded/shared-ui'

import { getNavigationItem } from '../../../common/utils/navigationInfo'

import { getSubNavigationItems } from './driver-shipments-navigation-items'

import PSMDriverDeliveryCardContainer from './psm-shipments/PSMDriverDelivery/PSMDriverDeliveryCardContainer'
import PackDeliveryModal from './PackDeliveryModal'

const PSMDeliveries = ({
  shipments,
  programs,
  locationName,
  showCompleted,
  config,
  loadOnlineDeliveries,
  history,
  isPsmResellerWarehouse,
  isWarehouseUser,
  onPackDelivery,
  onToggleCheckbox,
  selectedDeliveriesIds,
  packedDeliveriesIds,
  newDeliveriesIds,
  closeModal,
  showModal,
  setShowModal,
  packingInProgress
}) => {
  const canPsmResellerWarehouseUserMoveToPacked = hasFeature(config, 'features:psmResellerWarehouseUsersCanMoveShipmentsToPacked')

  const canPsmResellerWarehouseUsersPackUnroutedShipments = hasFeature(config, 'features:psmResellerWarehouseUsersCanMoveUnroutedShipmentsToPacked')

  const activeTab = showCompleted ? 'completed' : 'shipments'

  const isStartTripButtonDisabled = !!selectedDeliveriesIds.length
  const pageTitle = `${locationName} deliveries`

  const subNavigationItems = getSubNavigationItems({
    activeTab,
    isSelfPickup: isPsmResellerWarehouse
  })

  subNavigationItems.forEach(item => {
    if (item.active) {
      item.title = `${item.title} (${shipments.length})`
    }
  })

  const onStartPacking = () => {
    setShowModal(true)
  }

  const onStartTrip = () => {
    history.push({
      pathname: '/shipments/confirm-pick-up',
      state: { packedDeliveriesIds, selectedDeliveriesIds }
    })
  }

  return (
    <Page className='shipments'>
      <Page.ComposableHeader>
        <Page.ComposableHeader.Breadcrumb
          items={[getNavigationItem({ item: 'deliveries', config, includePath: false })]}
        />
        <Page.ComposableHeader.Content>
          <Page.ComposableHeader.Title title={pageTitle} />
          <Page.ComposableHeader.SubNavigation
            label=''
            items={subNavigationItems}
          />
        </Page.ComposableHeader.Content>
      </Page.ComposableHeader>

      <Page.Panel narrow alignLeft>
        <Fragment>
          <PSMDriverDeliveryCardContainer
            history={history}
            showCompleted={showCompleted}
            filteredShipments={shipments}
            selectedDeliveriesIds={selectedDeliveriesIds}
            packedDeliveriesIds={packedDeliveriesIds}
            newDeliveriesIds={newDeliveriesIds}
            onToggleCheckbox={onToggleCheckbox}
            programs={programs}
            isPsmResellerWarehouse={isPsmResellerWarehouse}
            isWarehouseUser={isWarehouseUser}
            canPsmResellerWarehouseUserMoveToPacked={canPsmResellerWarehouseUserMoveToPacked}
            canPsmResellerWarehouseUsersPackUnroutedShipments={canPsmResellerWarehouseUsersPackUnroutedShipments}
          />
        </Fragment>

        {loadOnlineDeliveries && (
          <div className='shipments__show-more'>
            <Button
              colorVariant='brand'
              fill='outline'
              size='small'
              onClick={loadOnlineDeliveries}
            >
              Show all completed deliveries (online)
            </Button>
          </div>
        )}
      </Page.Panel>
      {/* Warehouse user who can pack shipments sees button to pack them */}
      {(isWarehouseUser || canPsmResellerWarehouseUserMoveToPacked) && (
        <Page.Footer fixed nowrap>
          <Button
            colorVariant='brand'
            fill='full'
            disabled={!isStartTripButtonDisabled}
            onClick={onStartPacking}
          >
            Move to packed
          </Button>
        </Page.Footer>
      )}

      {/* Driver starts trip and gets directed to new flow */}
      {!isWarehouseUser && (
        <Page.Footer fixed nowrap>
          <Button
            colorVariant='brand'
            fill='full'
            disabled={!isStartTripButtonDisabled}
            onClick={onStartTrip}
          >
            Proceed to confirm deliveries
          </Button>
        </Page.Footer>
      )}
      <PackDeliveryModal
        isOpen={showModal}
        onClose={closeModal}
        onConfirm={onPackDelivery}
        loading={packingInProgress}
      />
    </Page>
  )
}

export default PSMDeliveries
